module.exports = __webpack_public_path__ + "images/playstore_2244310a4370dc6c382f40ed4e8be102.svg";